import { openDB, IDBPDatabase } from 'idb';
import { WorldInfo } from '../types';

const DB_NAME = 'mineraft-worlds';
const DB_VERSION = 1;

let db: IDBPDatabase | null = null;

export async function initDB(): Promise<void> {
  db = await openDB(DB_NAME, DB_VERSION, {
    upgrade(database) {
      if (!database.objectStoreNames.contains('worlds')) {
        database.createObjectStore('worlds', { keyPath: 'id' });
      }
      if (!database.objectStoreNames.contains('chunks')) {
        database.createObjectStore('chunks');
      }
      if (!database.objectStoreNames.contains('players')) {
        database.createObjectStore('players');
      }
    },
  });
}

export async function getWorlds(): Promise<WorldInfo[]> {
  if (!db) await initDB();
  return db!.getAll('worlds');
}

export async function saveWorld(info: WorldInfo): Promise<void> {
  if (!db) await initDB();
  await db!.put('worlds', info);
}

export async function deleteWorld(id: string): Promise<void> {
  if (!db) await initDB();
  await db!.delete('worlds', id);

  // Delete all chunks for this world
  const tx = db!.transaction('chunks', 'readwrite');
  const store = tx.objectStore('chunks');
  const keys = await store.getAllKeys();
  for (const key of keys) {
    if (typeof key === 'string' && key.startsWith(`${id}:`)) {
      await store.delete(key);
    }
  }
  await tx.done;
}

export async function saveChunk(worldId: string, cx: number, cz: number, data: Uint8Array): Promise<void> {
  if (!db) await initDB();
  await db!.put('chunks', data, `${worldId}:${cx}:${cz}`);
}

export async function loadChunk(worldId: string, cx: number, cz: number): Promise<Uint8Array | null> {
  if (!db) await initDB();
  const result = await db!.get('chunks', `${worldId}:${cx}:${cz}`);
  return result ?? null;
}

export async function savePlayerState(worldId: string, state: object): Promise<void> {
  if (!db) await initDB();
  await db!.put('players', state, worldId);
}

export async function loadPlayerState(worldId: string): Promise<object | null> {
  if (!db) await initDB();
  const result = await db!.get('players', worldId);
  return result ?? null;
}
